import { ArrowRight } from "lucide-react";

import type { OtcSellOrder } from "../../types/cryptoSell.types";
import { AssetAmount } from "../shared/AssetAmount";
import { AssetAvatar } from "../shared/CryptoSwapBits";

/** USDT deposited → pesos: the credit once there is one, the proceeds the sale expects until then. */
export function SaleAmounts({ sale, size = "xs" }: { sale: OtcSellOrder; size?: "xs" | "sm" }) {
  const pesos = sale.credit.amount ?? sale.proceeds.paid_amount ?? sale.proceeds.amount;
  return (
    <span className="inline-flex flex-wrap items-center gap-2 font-mono text-[13px]">
      <span className="inline-flex items-center gap-1.5">
        <AssetAvatar asset={sale.deposit.currency} kind="ONCHAIN" size="xs" />
        <AssetAmount
          value={sale.deposit.amount}
          currency={sale.deposit.currency}
          size={size}
          className="font-normal"
        />{" "}
        {sale.deposit.currency}
      </span>
      <ArrowRight aria-hidden="true" className="size-3 text-muted-foreground" />
      <span className="font-semibold">
        <AssetAmount value={pesos} currency={sale.proceeds.currency} size={size} className="font-semibold" />{" "}
        {sale.proceeds.currency}
      </span>
    </span>
  );
}
